





























































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,  TbSettingsPad,TbShop } from '@/http';
import { NumberKeyboard,dialogPanel } from "@/components";
import { Toast } from 'vant';
import QRCode from 'qrcodejs2'
import selectLabelPaper from "./selectLabelPaper.vue";
import changeMbTip from "./changeMbTip.vue";
import { TbShopLabelTemplate } from '@/http/api_TbShopLabelTemplate';
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
import {PrintLabelEvent1,PrintLabelEvent2} from "@/common/util/prints";
@Component({ 
    components: {
        NumberKeyboard,selectLabelPaper,changeMbTip,dialogPanel
    },
})
export default class xpInfo extends Vue {
   
    public $refs: {
    };
    userInfo = {};
    isEdit = false;
   
    labelPrinterName = "";
    isPrintLoading = false;
    shopInfo:any = {};
    isLoading1 = false;
    // 1、40*30 2、40*60 3、25*15 
    pageSize = null;
    padSetInfo:any={};

    putNum=1;
   
    labelInfo=[
    {
        articleNo: "此处显示货号",
        barCode: "123456789123456789",
        goodsClassName: "服装/女装",
        goodsId: "e4b1eac1-1c9f-472e-92b7-538015f17cd4",
        goodsSpecsId: "79,8",
        goodsSpecsName: "棉100%/江苏/藏蓝色",
        id: "635a471e-215c-4c56-8513-f7e84135aa63",
        isShelves: true,
        material: "蚕丝",
        name: "此处显示品名",
        qualityLevel: "A级",
        safetyLevel: "A级",
        saleNumber: 0,
        sellingPrice: 399, 
        shopId: "b090b108-5509-4bfc-a766-8f966fd90af1",
        shortBarCode: "123456789123456789",
        standard: "",
        stock: 1,
        supplierName: "四季服装城名称过长...",
        tick: true,
        washStr1: "",
        washStr2: "",
        washingMethod: "此处显示商品所维护的洗涤...",
    }
    ]
    labelInfo1=[
    {
        articleNo: "此处显示货号",
        barCode: "0002",
        goodsClassName: "服装/女装",
        goodsId: "e4b1eac1-1c9f-472e-92b7-538015f17cd4",
        goodsSpecsId: "79,8",
        goodsSpecsName: "棉100%/江苏",
        id: "635a471e-215c-4c56-8513-f7e84135aa63",
        isShelves: true,
        material: "蚕丝",
        name: "此处显示品名",
        qualityLevel: "A级",
        safetyLevel: "A级",
        saleNumber: 0,
        sellingPrice: 399, 
        shopId: "b090b108-5509-4bfc-a766-8f966fd90af1",
        shortBarCode: "0002",
        standard: "",
        stock: 1,
        supplierName: "四季服装城名称过长...",
        tick: true,
        washStr1: "",
        washStr2: "",
        washingMethod: "此处显示商品所维护的洗涤...",
    }
    ]
    labelInfo3=[
        {
          articleNo: "test01",
          barCode: "test01001",
          goodsClassName: "帽子/鸭舌帽",
          goodsId: "e4b1eac1-1c9f-472e-92b7-538015f17cd4",
          goodsSpecsId: "79,8",
          goodsSpecsName: "黑色/均码",
          id: "635a471e-215c-4c56-8513-f7e84135aa63",
          isShelves: true,
          material: "尼龙/弹性纤维",
          name: "男女同款夏款鸭舌帽",
          qualityLevel: "A级",
          safetyLevel: "优级",
          saleNumber: 0,
          sellingPrice: 299, 
          shopId: "b090b108-5509-4bfc-a766-8f966fd90af1",
          shortBarCode: "test01001",
          standard: "GB/T 2828.1",
          stock: 1,
          supplierName: "帽帽供应商",
          tick: true,
          washStr1: "",
          washStr2: "",
          washingMethod: "手洗或轻柔机洗",
          discountPrice:249,
          memberPriceRange:'199',
          goodsDesc:'运动款，透气轻便',
          isMemberDiscount:true,
        }
    ]
    get getPaperName(){
        let str = "";
        switch (this.pageSize) {
            case 1:
                str = "40mm*30mm"
                break;
            case 2:
                str = "40mm*60mm"
                break;
            case 3:
                str = "25mm*15mm"
                break;
        
            default:
                break;
        }
        return str;
    }
    
    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;

    firstSize = null;

    //判断是否是标签新版本 1新 0旧
    isnewLabel=0;
    editVal = 0;

    newTemplateId="";
    newTemplateName="";
    newTemplateType=null;

    /**预览 */
    previewShow = false;

    usedForm:any={};
    isloadingChange=false;

    get getWashArr(){
        let str="";
        let washArr=[];
        if(this.pageSize==2&&this.padSetInfo&&this.padSetInfo.settingContent){
            if(this.padSetInfo.settingContent.ironing&&this.padSetInfo.settingContent.ironing.isSelect){
                washArr.push('中温熨烫');
            }
            if(this.padSetInfo.settingContent.doNotWash&&this.padSetInfo.settingContent.doNotWash.isSelect){
                washArr.push('不可机洗');
            }
            if(this.padSetInfo.settingContent.noWring&&this.padSetInfo.settingContent.noWring.isSelect){
                washArr.push('不可拧干');
            }
            if(this.padSetInfo.settingContent.lowTemperature&&this.padSetInfo.settingContent.lowTemperature.isSelect){
                washArr.push('低温手洗');
            }
            if(this.padSetInfo.settingContent.dryClean&&this.padSetInfo.settingContent.dryClean.isSelect){
                washArr.push('标准干洗');
            }
            if(washArr.length>0){
                str=washArr.join('/');
            }
        }
        return str;
    }

    created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }
    async activated() {
        this.shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
    }
    async mounted(){
        this.shopInfo = await TbShop.GetTbShopById({id:this.userInfo['shopId']});
       
       
        await this.getInfo();
        this.$nextTick(()=>{
            this.editVal = this.isnewLabel;
        })
    }
    finishNum(val){
        this.putNum=val;
    }
    editInfo(){
        this.isEdit = true;
    }
    cancelInfo(){
        this.isEdit = false;
        this.getInfo();
    }
    async getMbVersion(){
        let res = await TbShop.GetInitShopInfo({shopid:this.shopInfo.id});
        this.isnewLabel = res.webShopLabelTemplateType;   
        
    }
    async getInfo(){
         if(localStorage.getItem('labelPaperSize')){
            let val =Number(localStorage.getItem('labelPaperSize'));
            console.log('val',val);
            if(this.userInfo['isJewelry']){
                this.pageSize = 3;
            }else{
                this.pageSize = val;
            }
        }else{
            if(this.userInfo['isJewelry']){
                this.pageSize = 3;
               
            }else{
                this.pageSize = 1;
            }
        }
        if(localStorage.getItem('isnewLabel')){
            this.isnewLabel= Number(localStorage.getItem('isnewLabel'));
        }else{
            await this.getMbVersion();
        }
         await this.init();
    };
    async init(){
       if(this.isnewLabel==0){
            await this.getOldDpInfo();
       }else{
            await this.getNewDpInfo();
       }
    }
    async getNewDpInfo(){
        let res = await  TbShopLabelTemplate.GetShopLabelTemplateList({ shopno:this.shopInfo.shopNo,
                            shopid:this.shopInfo.id,skip:0,count:1});
        if(res&&res.items.length>0){
            this.newTemplateId = res.items[0].id;
            let res2 = await TbShopLabelTemplate.GetTbShopLabelTemplateById({id:this.newTemplateId});
            this.padSetInfo =res2;
            this.putNum = res2.contentJson.labelTemplateMore.printNum;
            this.newTemplateName = res2.templateName;
            this.newTemplateType = res2.labelTemplateType;
        }else{
            this.padSetInfo = null;
        }
    }
    async getOldDpInfo(){
        if(this.pageSize==1){
              /**40*30 */
              let res =  await TbSettingsPad.GetTbSettings({settingtype:7});
              this.padSetInfo =res;
              if(res.settingContent.shopName){
                    this.padSetInfo.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
                }
            }else if(this.pageSize==2){
            /**40*60 */
            let res = await TbSettingsPad.GetTbSettings({settingtype:10});
            this.padSetInfo = res;
            if(res.settingContent.shopName){
                    this.padSetInfo.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
                }
            }else {
                /**25*15 */
                let res = await TbSettingsPad.GetTbSettings({settingtype:12});
                this.padSetInfo = res;
                if(res.settingContent.shopName){
                        this.padSetInfo.settingContent.shopName.value=res.settingContent.shopName.value?res.settingContent.shopName.value:this.shopInfo.shopName;
                    }
            }
            this.putNum = this.padSetInfo.settingContent.putNum?this.padSetInfo.settingContent.putNum:1;
            this.$forceUpdate();
    }
    async saveEdit(qhtype=null){
        if(!this.putNum||Number(this.putNum==0)){
            Toast("请输入打印份数");
            return
        }
        if(this.isLoading1) return;
        this.isLoading1 = true;let type = this.isnewLabel;
        await TbShop.PutWebShopLabelTemplateType({shopid:this.shopInfo.id,webShopLabelTemplateType:type});
        if(this.isnewLabel==0){
            this.padSetInfo.settingContent.putNum=this.putNum?this.putNum:1;
            try {
                if(this.pageSize==1){
                    await TbSettingsPad.PutTbSettings({
                        id:this.padSetInfo.id,
                        settingContent:JSON.stringify(this.padSetInfo.settingContent),
                    })
                }else if(this.pageSize==2){
                    await TbSettingsPad.PutTbSettings({
                        id:this.padSetInfo.id,
                        settingContent:JSON.stringify(this.padSetInfo.settingContent),
                    })
                }else{
                    await TbSettingsPad.PutTbSettings({
                        id:this.padSetInfo.id,
                        settingContent:JSON.stringify(this.padSetInfo.settingContent),
                    })
                }
                
                localStorage.setItem('labelPaperSize',this.pageSize);
                localStorage.removeItem('isnewLabel');
                await this.getInfo();
                this.isLoading1 = false;
                this.isEdit = false;
                Toast('保存成功');
            } catch (error) {
                this.isLoading1 = false;
            }
        }else{
            try {
                let moreInfo = Object.assign({},this.padSetInfo.contentJson.labelTemplateMore,{printNum:this.putNum})
                let form = {
                id:this.padSetInfo.id,
                templateName:this.padSetInfo.templateName,
                labelTemplateType:this.padSetInfo.labelTemplateType,
                contentJson:{
                        labelDatas:this.padSetInfo.contentJson.labelDatas,
                        labelTemplateMore:moreInfo,
                    }
                };
                await TbShopLabelTemplate.PutTbShopLabelTemplate(form);
                await this.init();
                this.isLoading1 = false;
                this.isEdit = false;
                Toast('保存成功');
            } catch (error) {
                this.isLoading1 = false;
            }
        }
    }
   
    async printTest(){
       if(this.isPrintLoading)return;
       if(this.isnewLabel==0){
            this.isPrintLoading = true;
            let resSetting= null;
            if(this.pageSize==1){
                resSetting = await TbSettingsPad.GetTbSettings({settingtype:7})
            }else if(this.pageSize==2){
                resSetting = await TbSettingsPad.GetTbSettings({settingtype:10})
            }else{
                resSetting = await TbSettingsPad.GetTbSettings({settingtype:12})
            }
            let size = this.pageSize==1?"1":this.pageSize==2?'2':"3";
            let form = {}
            if(Number(size)==3){
                form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfoArr:this.labelInfo1},{type:'label'},{paperSize:Number(size)})
            }else{
                form = Object.assign({},{settingContent:resSetting.settingContent},{orderInfoArr:this.labelInfo},{type:'label'},{paperSize:Number(size)})
            }
            console.log('form',form);
            let time = 3000*resSetting.settingContent.putNum
            setTimeout(()=>{
                this.isPrintLoading = false;
            },time)
           
            PrintLabelEvent1(form,resSetting.settingContent.putNum)
        }else{
            this.isPrintLoading = true;
            let res = await  TbShopLabelTemplate.GetShopLabelTemplateList({ shopno:this.shopInfo.shopNo,
                            shopid:this.shopInfo.id,skip:0,count:1});
            if(res.items.length>0){
                this.newTemplateId = res.items[0].id;
                let res2 = await TbShopLabelTemplate.GetTbShopLabelTemplateById({id:this.newTemplateId});
                let padSetInfo =res2;
                let putNum = res2.contentJson.labelTemplateMore.printNum;
                let time = 3000*putNum;
                setTimeout(()=>{
                    this.isPrintLoading = false;
                },time)
                let form = Object.assign({},{settingContent:padSetInfo},{orderInfoArr:this.labelInfo3},{type:'label'},{paperSize:padSetInfo.labelTemplateType})
                 PrintLabelEvent2(form,putNum,true)
            }
        }
    }
    goDpSet(){
        this.$emit('changeTab',{tabActive:4,childActive:this.pageSize});
        localStorage.setItem('isnewLabel',this.isnewLabel.toString());
    }
    choosePage(){
        if(this.userInfo['isJewelry']) return;
        this.$refs['selectLabelPaper'].showFun(this.pageSize,true);
    }
    async changeItem(val){
        if(!this.isEdit) return;
        this.firstSize = val;
        // if(this.isEdit) {
        //     this.tipTitle = "操作提醒";
        //     this.tipText = `当前模版配置信息尚未保存，需要保存吗？`;
        //     this.btnNums=2;
        //     this.confirmText = "保存并切换";
        //     this.cancelText = "取消"
        //     this.tipType = 1;
        //     this.$nextTick(()=>{
        //         this.tipShow = true;
        //     })
        //     return;
        // }
        this.pageSize = val;
        console.log('this.pageSize',this.pageSize);
        // localStorage.setItem('labelPaperSize',val);
        await this.init();
    }
    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                this.saveEdit(1);
                break;
            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    changeVersion(val){
        if(!this.isEdit) return;
        if(this.isloadingChange) return;
        if(this.editVal==val) return;
        this.editVal = val;
        if(val==1&&!localStorage.getItem('labelNotTip')){
            this.$refs['changeMbTip'].showFun();
        }else{
            this.changeMbConfirm();
        }
    }
    async changeMbConfirm(){
        if(this.isloadingChange) return;
			this.isloadingChange = true;
            Toast.loading({
                message:"切换中...",
                duration:0
            })
        if(this.editVal==1){
            await this.getNewDpInfo();
            if(!this.padSetInfo){
                Toast({
                    duration:4000,
                    message:'微信搜索“航富通”小程序，进入[打印设置]，将打印模板切换至“新版本”！'
                });
                this.init();
                Toast.clear();
                this.isloadingChange = false;
            }else{
                this.isnewLabel = this.editVal;
                this.init();
                Toast.clear();
                this.isloadingChange = false;
            }
        }else{
            this.isnewLabel = this.editVal;
            this.init();
            Toast.clear();
            this.isloadingChange = false;
        }
    }
    closePreview(){
        this.previewShow = false;
    }
    async showPreview(){
            if(this.isnewLabel==0){
                await this.getOldDpInfo();
                this.previewShow = true; 
               
            }else{
                await this.getNewDpInfo();
                this.usedForm = {};
                this.usedForm = Object.assign({},this.padSetInfo,this.usedForm);
                this.usedForm = Object.assign({},this.usedForm,{
                    list:this.usedForm.contentJson.labelDatas.filter(v=>v.isSelect).map(v=>{
                        return {
                            ...v,
                            info:v.key=='洗涤小贴士'? v.info.replaceAll(/,/g,'/'):v.info
                        }
                    }).sort((a, b) => a.index - b.index),
                    isPrintCurrency:this.usedForm.contentJson.labelTemplateMore.isPrintCurrency,
                    labelCurrencyType:this.usedForm.contentJson.labelTemplateMore.labelCurrencyType
                })
                this.$nextTick(()=>{
                    this.previewShow = true; 
                })
              
            }
    }
    labelPrintTest(){
        }
        getPaperSize(type){
            let name = '';
            if(type==1) {
                name = '40mm * 30mm';
            }else if(type==4) {
                name = '40mm * 60mm';
            }else if(type==5) {
                name = '30mm * 20mm';
            }else if(type==7) {
                name = '15mm * 25mm-双面挂签 总长76mm';
            }else if(type==6) {
                name = '25mm * 15mm';
            }else if(type==8) {
                name = '30mm * 15mm-双面挂签 总长75mm';
            }else if(type==9) {
                name = '15mm * 25mm-竖版质检标';
            }else if(type==10) {
                name = '20mm * 10mm-横版珠宝标签';
            }else{
                name = '40mm * 30mm';
            }
            return name;
        }
        getFhname(type){
            let name = '';
            switch (type) {
                case 1:
                    name='￥';
                    break;
                case 2:
                    name='$';
                    break;
                case 3:
                    name='HK$';
                    break;
                case 4:
                    name='MOP$';
                    break;
                case 5:
                    name='RM';
                    break;
                case 6:
                    name='NT$';
                    break;
                case 7:
                    name='OMR';
                    break;
                case 8:
                    name='THB';
                    break;
                default:
                    break;
            }
            return name;
        }
        getbasicData(type,isPrintCurrency,labelCurrencyType){
            let name = '';
            let currencyType = isPrintCurrency?this.getFhname(labelCurrencyType):'';
            switch (type) {
                case '门店名称':
                    name = this.shopInfo.shopName;
                    break;
                case '货号':
                    name='test01';
                    break;
                case '品名':
                    name='男女同款夏款鸭舌帽';
                    break;
                case '分类':
                    name='帽子/鸭舌帽';
                    break;
                case '零售价':
                    name=currencyType+'299.00';
                    break;
                case '折扣价':
                    name=currencyType+'249.00';
                    break;
                case '会员价':
                    name=currencyType+'199.00';
                    break;
                case '规格':
                    name='黑色/均码';
                    break;
                case '供应商':
                    name='帽帽供应商';
                    break;
                case '商品材质':
                    name='尼龙/弹性纤维';
                    break;
                case '质量等级':
                    name='A级';
                    break;
                case '安全等级':
                    name='优级';
                    break;
                case '洗涤方式':
                    name='手洗或轻柔机洗';
                    break;
                case '执行标准':
                    name='GB/T 2828.1';
                    break;
                case '商品说明':
                    name='运动款，透气轻便';
                    break;
                case '售价':
                    name='299';
                    break;
                case '洗涤小贴士':
                    name='中温熨烫/不可机洗/低温手洗';
                    break;
                case '自定义':
                    name='收银就用航富通';
                    break;
                default:
                    break;
            }
            return name;
        }
        getTm(type){
            let name = '';
            if(type==1) {
                name = 'test01001';
            }else if(type==4) {
                name = 'test01001';
            }else if(type==5) {
                name = '0002';
            }else if(type==7) {
                name = '0002';
            }else if(type==6) {
                name = '0002';
            }else if(type==8) {
                name = '0002';
            }else{
                name = 'test01001';
            }
            return name;
        }
        get labelSizeName(){
            let str = "";
            if(this.newTemplateType){
                switch (this.newTemplateType) {
                    case 1:
                    str="40mm*30mm"
                    break;
                    case 2:
                    str="40mm*30mm"
                    break;
                    case 3:
                    str="40mm*30mm"
                    break;
                    case 4:
                    str="40mm*60mm"
                    break;
                    case 5:
                    str="30mm*20mm"
                    break;
                    case 6:
                    str="25mm*15mm"
                    break;
                    case 7:
                    str="15mm*25mm-双面挂签"
                    break;
                    case 8:
                    str="30mm*15mm-双面挂签"
                    break;
                    case 9:
                    str="15mm*25mm-竖版质检标双面"
                    break;
                    case 10:
                    str="20mm*10mm-横版珠宝标签"
                    break;
                
                    default:
                    break;
                }
            }
            return str;
    }
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/setting/components/dpSetting.vue